// Vendors
import { Container } from "pixi.js";
import { gsap, TweenMax } from "gsap";
// Levels
import { LevelObject } from "shared/levels";
import { EventBus } from "shared/emmiter";
import { Main } from "screens/main";

export class BackgroundReleaseMechanicOld extends Container {

    protected level;
    protected tileColors: any[];
    protected tileTexture: any[];
    protected clusters;
    protected moves;
    protected drag = false;
    protected currentMove = { column1: 0, row1: 0, column2: 0, row2: 0 };
    protected gamestates;
    protected gamestate;
    public score: number = 0;
    protected animationstate;
    protected animationtime;
    protected animationtimetotal;
    protected showmoves;
    protected aibot;
    protected gameover;
    protected buttons;
    protected tileGraph: any;
    protected tileBack: any;
    protected ticker: any;

    protected num: number = 0;

    constructor() {

        super();

        this.name = 'game_play';

        // LevelObject = {
        //     x: 0,         // X position
        //     y: 0,         // Y position
        //     columns: 7,     // Number of tile columns
        //     rows: 7,        // Number of tile rows
        //     tileWidth: 70,  // Visual width of a tile
        //     tileHeight: 70, // Visual height of a tile
        //     tiles: [],      // The two-dimensional tile array
        //     selectedTile: { selected: false, column: 0, row: 0 }
        // };

        // this.tileBack = new Graphics();
        // this.tileBack.name = 'tile_back'
        // this.tileGraph = new Graphics();
        // this.addChild(this.tileBack, this.tileGraph);        

        // this.tileColors = [
        //     [255, 128, 128],
        //     [128, 255, 128],
        //     [128, 128, 255],
        //     [255, 255, 128],
        //     [255, 128, 255],
        //     [128, 255, 255],
        //     [255, 255, 255]
        // ];
        // this.tileTexture = [
        //     'tile_0',
        //     'tile_1',
        //     'tile_2',
        //     'tile_3',
        //     'tile_4',
        // ];

        // Clusters and moves that were found
        this.clusters = [];  // { column, row, length, horizontal }
        this.moves = [];     // { column1, row1, column2, row2 }

        // Current move
        this.currentMove = { column1: 0, row1: 0, column2: 0, row2: 0 };

        // Game states
        this.gamestates = { init: 0, ready: 1, resolve: 2 };
        this.gamestate = this.gamestates.init;

        // Score
        this.score = 0;

        // Animation variables
        this.animationstate = 0;
        this.animationtime = 0;
        this.animationtimetotal = 0.3;

        // Show available moves
        this.showmoves = false;

        // The AI bot
        this.aibot = false;

        // Game Over
        this.gameover = false;

        // Gui buttons
        // this.buttons = [ { x: 30, y: 240, width: 150, height: 50, text: "New Game"},
        //                 { x: 30, y: 300, width: 150, height: 50, text: "Show Moves"},
        //                 { x: 30, y: 360, width: 150, height: 50, text: "Enable AI Bot"}];


        this.init();
    }

    protected init() {

        // Add mouse events
        this.interactive = true;
        // this.on("pointermove", this.onMouseMove);

        this.on("pointerdown", this.onMouseDown);
        this.on("pointerup", this.onMouseUp);
        this.on("pointerout", this.onMouseOut);

        // Initialize the two-dimensional tile array
        for (var i = 0; i < LevelObject.columns; i++) {
            LevelObject.tiles[i] = [];
            for (var j = 0; j < LevelObject.rows; j++) {
                // Define a tile type and a shift parameter for animation
                LevelObject.tiles[i][j] = { type: 0, shift: 0, id: 0, isDelete: false }
            }
        }

        // New game
        this.newGame();

        // Draw level background
        var levelWidth = LevelObject.columns * LevelObject.tileWidth;
        var levelHeight = LevelObject.rows * LevelObject.tileHeight;
        // this.tileBack.beginFill(0x000000);
        // this.tileBack.drawRect(LevelObject.x - 4, LevelObject.y - 4, levelWidth + 8, levelHeight + 8);
        // this.tileBack.drawRect(-4, -4, levelWidth + 8, levelHeight + 8);

        // Render tiles
        // this.renderTiles();

        // Enter main loop
        // this.main(0);
    }

    protected newGame() {
        // Reset score
        this.score = 0;

        // Set the gamestate to ready
        this.gamestate = this.gamestates.ready;

        // Reset game over
        this.gameover = false;

        // Create the level
        this.createLevel();

        this.drawTiles();

        // Find initial clusters and moves
        // this.findMoves();
        // this.findClusters();

        EventBus.emmiter.on('reset_game', () => {
            this.score = 0;
        })
    }

    protected drawTiles() {
        for (var i = 0; i < LevelObject.columns; i++) {
            for (var j = 0; j < LevelObject.rows; j++) {
                // Get the shift of the tile for animation
                var shift = LevelObject.tiles[i][j].shift;

                // Calculate the tile coordinates
                var coord = this.getCoordinateTile(i, j);

                // Check if there is a tile present
                if (LevelObject.tiles[i][j].type >= 0) {
                    // Get the color of the tile
                    var texture = LevelObject.tiles[i][j].type;
                    // Draw the tile using the color
                    let tile = this.createTile(coord.tileX, coord.tileY, texture, i, j);
                    LevelObject.tiles[i][j].tile = tile;
                    // this.drawTile(coord.tilex, coord.tiley, col[0], col[1], col[2]);
                }
            }
        }
    }

    protected createTile(x, y, color, i, j) {
        let tile;
        switch (color) {
            case 0: {
                tile = new PIXI.Sprite(Main.instance.app.loader.resources.red.texture);
                break;
            }
            case 1: {
                tile = new PIXI.Sprite(Main.instance.app.loader.resources.pink.texture);
                break;
            }
            case 2: {
                tile = new PIXI.Sprite(Main.instance.app.loader.resources.dark_purp.texture);
                break;
            }
            case 3: {
                tile = new PIXI.Sprite(Main.instance.app.loader.resources.purp.texture);
                break;
            }
            case 4: {
                tile = new PIXI.Sprite(Main.instance.app.loader.resources.tile_5.texture);
                break;
            }
        }

        // const tile = new Sprite(MyLoader.getResource(texture).texture);
        // const tile = new Tile({
        //     resource: texture
        // })
        tile.name = `sprite_${i}_${j}`
        tile.width = LevelObject.tileWidth - 5;
        tile.height = LevelObject.tileHeight - 5;
        tile.x = x;
        tile.y = y;
        this.addChild(tile);

        return tile;
    }

    protected createLevel() {
        var done = false;

        // Keep generating levels until it is correct
        while (!done) {

            // Create a level with random tiles
            let id = 0;
            for (var i = 0; i < LevelObject.columns; i++) {
                for (var j = 0; j < LevelObject.rows; j++) {
                    LevelObject.tiles[i][j].type = this.getRandomTile();
                    LevelObject.tiles[i][j].id = id;
                    id++;
                }
            }

            // Resolve the clusters
            this.resolveClusters(true);

            // Check if there are valid moves
            this.findMoves();
            // Done when there is a valid move
            if (this.moves.length > 0) {
                done = true;
            }
        }
    }

    protected async resolveClusters(isStart: boolean): Promise<boolean> {
        // Check for clusters
        let clusters = this.findClusters();
        let isClusters = false;
        if (clusters.length > 0) {
            isClusters = true;
        }
        // While there are clusters left

        while (this.clusters.length > 0) {

            // Remove clusters
            // ANIMA
            // await this.removeClusters();
            this.removeClusters();

            // Shift tiles
            this.shiftTiles(isStart);

            // Check if there are clusters left
            clusters = this.findClusters();
        }

        return isClusters;
    }

    // Remove the clusters
    protected async removeClusters(): Promise<void> {
        // Change the type of the tiles to -1, indicating a removed tile
        // debugger
        // ANIMA
        // await this.loopClusters(async (index, column, row, cluster) => {
        //     const tile = LevelObject.tiles[column][row].tile;
        //     await new Promise((res, rej) => {
        //         gsap.to(tile, {alpha: 1, duration: 0.3, onComplete: () => {
        //             LevelObject.tiles[column][row].type = -1;
        //             res();
        //         }})
        //     })
        // });

        this.loopClusters((index, column, row, cluster) => {
            LevelObject.tiles[column][row].type = -1;
            LevelObject.tiles[column][row].isDelete = true;
        });

        // Calculate how much a tile should be shifted downwards
        for (var i = 0; i < LevelObject.columns; i++) {
            var shift = 0;
            for (var j = LevelObject.rows - 1; j >= 0; j--) {
                // Loop from bottom to top
                if (LevelObject.tiles[i][j].type == -1) {
                    // Tile is removed, increase shift
                    LevelObject.tiles[i][j].isDelete = true;
                    shift++;
                    LevelObject.tiles[i][j].shift = 0;
                    // if(LevelObject.tiles[i][j].tile.explosion) {
                    //     await LevelObject.tiles[i][j].tile.explosion();
                    // }

                } else {
                    // Set the shift
                    LevelObject.tiles[i][j].shift = shift;
                }
            }
        }
    }

    // Loop over the cluster tiles and execute a function
    protected async loopClusters(func) {
        for (var i = 0; i < this.clusters.length; i++) {
            //  { column, row, length, horizontal }
            var cluster = this.clusters[i];
            var coffset = 0;
            var roffset = 0;
            for (var j = 0; j < cluster.length; j++) {

                // ANIMA
                // if (j === cluster.length - 1) {
                //     await func(i, cluster.column + coffset, cluster.row + roffset, cluster);
                // } else {
                //     func(i, cluster.column + coffset, cluster.row + roffset, cluster);
                // }
                func(i, cluster.column + coffset, cluster.row + roffset, cluster);

                if (cluster.horizontal) {
                    coffset++;
                } else {
                    roffset++;
                }
            }
        }
    }

    // Shift tiles and insert new tiles
    protected async shiftTiles(isStart: boolean): Promise<void> {
        // Shift tiles
        for (var i = 0; i < LevelObject.columns; i++) {
            for (var j = LevelObject.rows - 1; j >= 0; j--) {
                // Loop from bottom to top
                if (LevelObject.tiles[i][j].type == -1) {
                    // Insert new random tile
                    // LevelObject.tiles[i][j].anim = true;

                    if (isStart) {
                        LevelObject.tiles[i][j].type = this.getRandomTile();
                    }

                    // gsap.to(LevelObject.tiles[i][j].tile, {alpha: 0})
                } else {
                    // Swap tile to shift it
                    var shift = LevelObject.tiles[i][j].shift;
                    if (shift > 0) {
                        this.swap(i, j, i, j + shift)
                    }
                }

                // Reset shift
                LevelObject.tiles[i][j].shift = 0;
            }
        }
    }

    protected findClusters() {
        // Reset clusters
        this.clusters = [];

        // Find horizontal clusters
        for (var j = 0; j < LevelObject.rows; j++) {
            // Start with a single tile, cluster of 1
            var matchLength = 1;
            for (var i = 0; i < LevelObject.columns; i++) {
                var checkCluster = false;

                if (i == LevelObject.columns - 1) {
                    // Last tile
                    checkCluster = true;
                } else {
                    // Check the type of the next tile
                    if (LevelObject.tiles[i][j].type === LevelObject.tiles[i + 1][j].type &&
                        LevelObject.tiles[i][j].type !== -1) {
                        // Same type as the previous tile, increase matchLength
                        matchLength += 1;
                    } else {
                        // Different type

                        checkCluster = true;
                    }
                }

                // Check if there was a cluster
                if (checkCluster) {
                    if (matchLength >= 3) {
                        // Found a horizontal cluster
                        this.clusters.push({
                            column: i + 1 - matchLength, row: j,
                            length: matchLength, horizontal: true
                        });
                        // if (matchLength >= 3) {
                        //     this.score = this.score + LevelObject.scoreCounter * matchLength;
                        //     FillBarService.changeBarFill(this.score);
                        //     this.score = 0;
                        // }
                    }

                    matchLength = 1;
                }
            }
        }

        // Find vertical clusters
        for (var i = 0; i < LevelObject.columns; i++) {
            // Start with a single tile, cluster of 1
            var matchlength = 1;
            for (var j = 0; j < LevelObject.rows; j++) {
                var checkcluster = false;

                if (j == LevelObject.rows - 1) {
                    // Last tile
                    checkcluster = true;
                } else {
                    // Check the type of the next tile
                    if (LevelObject.tiles[i][j].type === LevelObject.tiles[i][j + 1].type &&
                        LevelObject.tiles[i][j].type !== -1) {
                        // if (LevelObject.tiles[i][j].tile && LevelObject.tiles[i][j + 1].tile) {
                        //     matchlength += 1;
                        // }
                        // Same type as the previous tile, increase matchlength
                        matchlength += 1;

                    } else {
                        // Different type
                        checkcluster = true;
                    }
                }

                // Check if there was a cluster
                if (checkcluster) {
                    if (matchlength >= 3) {
                        // Found a vertical cluster
                        LevelObject.tiles[i][j]
                        this.clusters.push({
                            column: i, row: j + 1 - matchlength,
                            length: matchlength, horizontal: false
                        });
                        // if (matchlength >= 3) {
                        //     this.score = this.score + LevelObject.scoreCounter * matchlength;
                        //     FillBarService.changeBarFill(this.score);
                        //     this.score = 0;
                        // }
                    }

                    matchlength = 1;
                }
            }
        }
        return this.clusters;
    }

    // Find available moves
    protected findMoves() {
        // Reset moves
        this.moves = []

        // Check horizontal swaps
        for (var j = 0; j < LevelObject.rows; j++) {
            for (var i = 0; i < LevelObject.columns - 1; i++) {
                // Swap, find clusters and swap back
                this.swap(i, j, i + 1, j);
                this.findClusters();
                this.swap(i, j, i + 1, j);


                // Check if the swap made a cluster
                if (this.clusters.length > 0) {
                    if (LevelObject.tiles[i][j].type !== -1 &&
                        LevelObject.tiles[i + 1][j].type !== -1) {
                            // Found a move
                            this.moves.push({ column1: i, row1: j, column2: i + 1, row2: j });
                        }
                }
            }
        }

        // Check vertical swaps
        for (var i = 0; i < LevelObject.columns; i++) {
            for (var j = 0; j < LevelObject.rows - 1; j++) {
                // Swap, find clusters and swap back
                this.swap(i, j, i, j + 1);
                this.findClusters();
                this.swap(i, j, i, j + 1);

                // Check if the swap made a cluster
                if (this.clusters.length > 0) {
                    if (LevelObject.tiles[i][j].type !== -1 &&
                        LevelObject.tiles[i][j + 1].type !== -1) {
                            // Found a move
                            this.moves.push({ column1: i, row1: j, column2: i, row2: j + 1 });
                        }
                }
            }
        }

        if (this.moves.length === 0) {
            this.addLine();
        }
        // Reset clusters
        this.clusters = []
    }

    protected async addLine() {
        for (let i = 0; i < LevelObject.columns; i++) {
            for (let j = 0; j < LevelObject.rows; j++) {
                if (LevelObject.tiles[i][j + 1] && LevelObject.tiles[i][j].type === -1
                    && LevelObject.tiles[i][j + 1].type !== -1) {
                    const type = this.getRandomTile()
                    let texture = this.getTexture(type);
                    LevelObject.tiles[i][j].type = type;
                    LevelObject.tiles[i][j].isDelete = false;

                    LevelObject.tiles[i][j].tile.texture = texture;
                    LevelObject.tiles[i][j].tile.alpha = 1;
                } else if (!LevelObject.tiles[i][j + 1] && LevelObject.tiles[i][j].type === -1) {
                    const type = this.getRandomTile()
                    let texture = this.getTexture(type);
                    LevelObject.tiles[i][j].type = type;
                    LevelObject.tiles[i][j].isDelete = false;

                    LevelObject.tiles[i][j].tile.texture = texture;
                    LevelObject.tiles[i][j].tile.alpha = 1;
                }
            }
        }
        this.resolveClusters(false).then((res) => {
            this.findMoves();
        })
    }

    protected getRandomTile() {
        return Math.floor(Math.random() * 5);
        // return Math.floor(Math.random() * this.tileColors.length);
    }

    protected getCoordinateTile(column, row) {
        var tileX = column * LevelObject.tileWidth;
        var tileY = row * LevelObject.tileHeight;
        // var tileX = LevelObject.x + column  * LevelObject.tileWidth;
        // var tileY = LevelObject.y + row * LevelObject.tileHeight;
        return { tileX: tileX, tileY: tileY };
    }

    // On mouse button click
    protected onMouseDown(e) {

        // Get the mouse position
        var pos = this.getMousePos(this, e);

        // Start dragging
        if (!this.drag) {
            // Get the tile under the mouse
            let mt = this.getMouseTile(pos);
            if (mt.valid) {
                // Valid tile
                var swapped = false;
                let selectedTile = LevelObject.tiles[LevelObject.selectedTile.column][LevelObject.selectedTile.row];
                if (LevelObject.selectedTile.selected) {
                    for (var i = 0; i < LevelObject.columns; i++) {
                        for (var j = 0; j < LevelObject.rows; j++) {
                            let selectedTile = LevelObject.tiles[i][j];
                            if (selectedTile.tile) {
                                selectedTile.tile.alpha = 1;
                            }
                        }
                    }

                    if (mt.x == LevelObject.selectedTile.column && mt.y == LevelObject.selectedTile.row) {
                        // Same tile selected, deselect
                        LevelObject.selectedTile.selected = false;
                        this.drag = true;

                        selectedTile.tile.alpha = 1;
                        return;
                    } else if (this.canSwap(mt.x, mt.y, LevelObject.selectedTile.column, LevelObject.selectedTile.row)) {
                        // Tiles can be swapped, swap the tiles
                        this.swapTiles(mt.x, mt.y, LevelObject.selectedTile.column, LevelObject.selectedTile.row);
                        swapped = true;
                    }
                }

                if (!swapped) {
                    // Set the new selected tile
                    LevelObject.selectedTile.column = mt.x;
                    LevelObject.selectedTile.row = mt.y;
                    LevelObject.selectedTile.selected = true;
                }
            } else {
                // Invalid tile
                LevelObject.selectedTile.selected = false;
            }

            // Start dragging
            this.drag = true;
        }

        for (var i = 0; i < LevelObject.columns; i++) {
            for (var j = 0; j < LevelObject.rows; j++) {

                // Draw the selected tile
                if (LevelObject.selectedTile.selected) {
                    if (LevelObject.selectedTile.column == i && LevelObject.selectedTile.row == j) {
                        // Draw a red tile
                        let selectedTile = LevelObject.tiles[LevelObject.selectedTile.column][LevelObject.selectedTile.row];
                        selectedTile.tile.alpha = 0.5;
                    }
                }
            }
        }

        // this.renderTiles();
    }

    protected swapTiles(c1, r1, c2, r2) {
        // Save the current move
        // this.currentMove = {column1: c1, row1: r1, column2: c2, row2: r2};
        const currentMove = { column1: c1, row1: r1, column2: c2, row2: r2 };
        // Deselect
        LevelObject.selectedTile.selected = false;

        const coord1 = this.getCoordinateTile(currentMove.column1, currentMove.row1);
        const coord2 = this.getCoordinateTile(currentMove.column2, currentMove.row2);

        const tile1 = LevelObject.tiles[c1][r1].tile;
        const tile2 = LevelObject.tiles[c2][r2].tile;



        TweenMax.to(tile1, .3, {
            x: coord2.tileX,
            y: coord2.tileY
        });

        TweenMax.to(tile2, .3, {
            x: coord1.tileX,
            y: coord1.tileY,
            onComplete: () => {
                [LevelObject.tiles[c1][r1], LevelObject.tiles[c2][r2]] = [LevelObject.tiles[c2][r2], LevelObject.tiles[c1][r1]];
                this.resolveClusters(false).then((res) => {
                    if (res) {
                        this.updatedTiles();
                    } else {
                        [LevelObject.tiles[c1][r1], LevelObject.tiles[c2][r2]] = [LevelObject.tiles[c2][r2], LevelObject.tiles[c1][r1]];
                        TweenMax.to(tile1, .3, {
                            x: coord1.tileX,
                            y: coord1.tileY,
                        });

                        TweenMax.to(tile2, .3, {
                            x: coord2.tileX,
                            y: coord2.tileY
                        });
                    }
                });
            }
        });

        // Start animation

    }

    // Get the tile under the mouse
    protected getMouseTile(pos) {
        // Calculate the index of the tile
        var tx = Math.floor((pos.x) / LevelObject.tileWidth);
        var ty = Math.floor((pos.y) / LevelObject.tileHeight);
        // var tx = Math.floor((pos.x - LevelObject.x) / LevelObject.tileWidth);
        // var ty = Math.floor((pos.y - LevelObject.y) / LevelObject.tileHeight);

        // Check if the tile is valid
        if (tx >= 0 && tx < LevelObject.columns && ty >= 0 && ty < LevelObject.rows) {
            // Tile is valid
            return {
                valid: true,
                x: tx,
                y: ty
            };
        }

        // No valid tile
        return {
            valid: false,
            x: 0,
            y: 0
        };
    }

    // Check if two tiles can be swapped
    protected canSwap(x1, y1, x2, y2) {
        // Check if the tile is a direct neighbor of the selected tile
        if ((Math.abs(x1 - x2) === 1 && y1 === y2) ||
            (Math.abs(y1 - y2) === 1 && x1 === x2)) {
            return true;
        }

        return false;
    }

    protected swap(x1, y1, x2, y2) {
        var typeSwap = LevelObject.tiles[x1][y1].type;
        LevelObject.tiles[x1][y1].type = LevelObject.tiles[x2][y2].type;
        LevelObject.tiles[x2][y2].type = typeSwap;
    }

    protected onMouseUp(e) {
        // Reset dragging
        this.drag = false;
    }

    protected onMouseOut(e) {
        // Reset dragging
        this.drag = false;
    }

    // Get the mouse position
    protected getMousePos(canvas, e) {
        var rect = canvas.getBounds();
        return {
            x: Math.round((e.data.global.x - rect.left) / (rect.right - rect.left) * canvas.width),
            y: Math.round((e.data.global.y - rect.top) / (rect.bottom - rect.top) * canvas.height)
        };
    }

    protected async updatedTiles() {
        for (var i = 0; i < LevelObject.columns; i++) {
            for (var j = 0; j < LevelObject.rows; j++) {
                const textureName = LevelObject.tiles[i][j].type;
                let textureUpd = this.getTexture(textureName);

                const tile = LevelObject.tiles[i][j].tile;
                // if(this.level.tiles[i][j].type === -1) await tile.explosion();
                // tile.changeTexture(textureUpd);
                // tile.explosion();


                if (tile) {
                    tile.texture = textureUpd;
                }
            }
        }

        // FillBarService.changeBarFill(this.score)
        this.score = 0;
        this.findMoves();
    }

    private getTexture(type: number) {
        let texture;
        switch (type) {
            case 0: {
                texture = Main.instance.app.loader.resources.red.texture;
                break;
            }
            case 1: {
                texture = Main.instance.app.loader.resources.pink.texture;
                break;
            }
            case 2: {
                texture = Main.instance.app.loader.resources.dark_purp.texture;
                break;
            }
            case 3: {
                texture = Main.instance.app.loader.resources.purp.texture;
                break;
            }
            case 4: {
                texture = Main.instance.app.loader.resources.tile_5.texture;
                break;
            }
        }

        return texture;
    }
}